import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';

import './InfoTooltip.scss';

export const InfoTooltip = ({ message }) => (
    <Tooltip
        arrow={true}
        title={message}
        classes={{
            tooltip: 'tooltip-content'
        }}
        placement="bottom-end"
    >
        <i className="material-icons info-icon">info_outline</i>
    </Tooltip>
);
